const flattenDeep = (arr1) => {
  return arr1.reduce(
    (acc, val) =>
      Array.isArray(val) ? acc.concat(flattenDeep(val)) : acc.concat(val),
    []
  );
};

export const generateStartPosition = () => {
  let arrangement = new Array(8);

  // Places a piece on a square
  const place = (piece, square) => (arrangement[square] = piece);

  let squares = [
    [0, 2, 4, 6], // Dark squares (a, c, e, g)
    [1, 3, 5, 7], // Bright squares (b, d, f, h)
  ];

  // Process pieces in groups, emulating the single die method by Ingo Althofer
  const pieces = [
    ["B", "B"], // First bishops
    ["Q", "N", "N"], // Then queen and knights
    ["R", "K", "R"], // Finally king and rooks
  ];

  // Place each bishop on a random black/white square
  pieces[0].forEach((piece, squareColor) => {
    let index = Math.floor(Math.random() * 4);

    // Place the piece on the given square
    place(piece, squares[squareColor][index]);

    // Remove the square from the array of squares, as it is now taken
    squares[squareColor].splice(index, 1);
  });

  // Flatten the array of squares for the remaining pieces
  squares = flattenDeep(squares).sort();

  // Place queen and knights on random remaining squares
  pieces[1].forEach((piece) => {
    let index = Math.floor(Math.random() * squares.length);
    place(piece, squares[index]);
    squares.splice(index, 1);
  });

  // Place king and rooks on the remaining squares, the king in the middle
  pieces[2].forEach((piece) => {
    place(piece, squares[0]);
    squares.splice(0, 1);
  });

  arrangement = arrangement.join("");
  return `${arrangement.toLowerCase()}/pppppppp/8/8/8/8/PPPPPPPP/${arrangement} w - - 0 1`;
};
